var chunkPrefetchChunkToChildrenMap = {"3987":[6718],"2167":[6718]};
__webpack_require__.f.prefetch = (chunkId, promises) => {
  Promise.all(promises).then(() => {
    var chunks = chunkPrefetchChunkToChildrenMap[chunkId];
    Array.isArray(chunks) && chunks.map(__webpack_require__.E);
  });
};
